import { iconSvg } from '@brighterly/lib-lumee-ui'

import type { PipPalette } from './pip-colors'

export const ICON_MIC_ON = iconSvg('microphone', 'solid')
export const ICON_MIC_OFF = iconSvg('microphone-slash', 'solid')
export const ICON_CAM_ON = iconSvg('video', 'solid')
export const ICON_CAM_OFF = iconSvg('video-slash', 'solid')
export const ICON_USER = iconSvg('user', 'solid')

export const buildPipStyles = (palette: PipPalette): string => `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body { width: 100%; height: 100%; overflow: hidden; }
  body { background: ${palette.canvas}; font-family: system-ui, -apple-system, sans-serif; }
  .pip { position: relative; width: 100%; height: 100%; }
  .pip__tiles { display: flex; flex-direction: column; gap: 4px; width: 100%; height: 100%; padding: 4px; }
  .pip__tile { position: relative; flex: 1 1 50%; min-height: 0; overflow: hidden; border-radius: 12px; background: ${palette.tile}; }
  .pip__tile--absent { display: none; }
  .pip__video { display: block; width: 100%; height: 100%; object-fit: cover; }
  .pip__tile--empty .pip__video { display: none; }
  .pip__placeholder { display: none; position: absolute; inset: 0; align-items: center; justify-content: center; color: ${palette.placeholder}; }
  .pip__placeholder svg { width: 30%; max-width: 48px; }
  .pip__tile--empty .pip__placeholder { display: flex; }
  .pip__label { position: absolute; top: 8px; left: 8px; padding: 2px 8px; border-radius: 8px; background: ${palette.labelBackground}; color: ${palette.label}; font-size: 12px; line-height: 16px; }
  .pip__controls { position: absolute; bottom: 10px; left: 50%; display: flex; gap: 10px; transform: translateX(-50%); }
  .pip__control { display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border: none; border-radius: 50%; background: ${palette.control}; color: ${palette.controlIcon}; cursor: pointer; }
  .pip__control:hover { background: ${palette.controlHover}; }
  .pip__control svg { width: 18px; height: 18px; }
  .pip__control--off { background: ${palette.controlOff}; }
  .pip__control--off:hover { background: ${palette.controlOffHover}; }
`
